import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { RoleplayService, StepperContent } from '../../service/roleplay/roleplay.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrl: './stepper.component.scss',
    standalone: false
})
export class StepperComponent implements OnInit, OnChanges {
  subscription: Subscription;
  currentStepper: number = 1;
  @Input() isEditMode: boolean;
  @Output() changeStepperEvent = new EventEmitter();
  isEditable: boolean = false;
  stepperContent:StepperContent[] = [];

  constructor(public Router: Router, private sharedService: RoleplayService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isEditMode']) {
      this.isEditable = changes['isEditMode'].currentValue
    }
  }

  ngOnInit(): void {
    this.stepperContent = this.sharedService.stepperContent;
    this.subscription = this.sharedService.stepperData.subscribe((results) => {
      this.currentStepper = results.current;
    });
  }

  goToStep(id:number) {
    this.currentStepper = id;
    const stepper_data:StepperContent = this.sharedService.stepperContent.find(stepper=>stepper.stepId == id);
    console.log('Stepper : goToStep: ', id, stepper_data);
    this.changeStepperEvent.emit(stepper_data);
  }
}
